import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OperatorshiftsService } from 'app/services/operatorshifts.service';
import { ShiftsService } from 'app/services/shifts.service';

interface Operador {
  id: number;
  nombre: string;
}

interface TurnoData {
  operadores: Operador[];
  turnoSeleccionado?: number;
  operadorSeleccionado?: number;
}

@Component({
  selector: 'app-turnos-asignar',
  templateUrl: './asignar-turno.component.html',
  styleUrls: ['./asignar-turno.component.css']
})
export class TurnosAsignarComponent implements OnInit {
  form: FormGroup;
  operadores: Operador[] = [];
  turnos = [];

  constructor(
    private shiftService: ShiftsService,
    private shiftOperatorService: OperatorshiftsService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TurnosAsignarComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TurnoData
  ) {
    this.operadores = data.operadores;
  }

  ngOnInit(): void {
    this.initForm();
    this.getTurnos();
  }

  private initForm(): void {
    this.form = this.fb.group({
      operatorId: [this.data.operadorSeleccionado || '', Validators.required],
      shiftId: [this.data.turnoSeleccionado || '', Validators.required]
    });
  }

  getOperadores() {

  }

  getTurnos() {
    this.shiftService.getTurnos().subscribe(
      (data: any) => {
        this.turnos = data;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  onSubmit(): void {
    if (this.form.valid) {
      // eviamos la petición al servidor
      this.shiftOperatorService.saveTurnoOperador(this.form.value).subscribe(
        (data: any) => {
          // Mostrar mensaje de éxito
          import('sweetalert2').then(Swal => {
            Swal.default.fire({
              title: 'Operación exitosa',
              text: 'Se ha asignado el operador al turno correctamente',
              icon: 'success',
              confirmButtonText: 'Aceptar'
            }).then(() => {
              this.dialogRef.close(this.form.value);
            });
          });
        },
        (error) => {
            import('sweetalert2').then(Swal => {
              Swal.default.fire({
              title: 'No es posible asignar el turno',
              text: error.message,
              });
            });
        }
      );     
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}